import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-400">
      <Link to="/" className="transition-colors hover:text-accent-400">
        <i className="ri-home-4-line mr-1"></i>
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-background-500"></i>
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-accent-400">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-200">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}